import dayjs from 'dayjs';

// Define a type for filtering options
export type FilterOption = "Last 7 Days" | "Last Month" | "Recently Added" | "Ascending" | "Descending";

// Generic filter function
export const filterData = <T extends Record<string, unknown>>(
  data: T[],
  filters: { [key: string]: unknown },
  dateField: string,
  sortField: string,
  selectedSort: FilterOption
): T[] => {
  if (!Array.isArray(data)) return [];

  let filteredData = [...data];

  // Apply filters (e.g., active/inactive)
  Object.keys(filters).forEach((filterKey) => {
    const filterValue = filters[filterKey];
    if (filterValue !== undefined && filterValue !== null) {
      filteredData = filteredData.filter((item) => {
        const itemValue = item[filterKey];
        if (typeof itemValue === 'number' && typeof filterValue === 'number') {
          return itemValue === filterValue; // Both are numbers
        }
        if (typeof itemValue === 'string' && typeof filterValue === 'string') {
          return itemValue.trim() === filterValue.trim(); // Both are strings
        }
        return false;
      });
    }
  });


  const now = dayjs();

  // Convert string dates to dayjs objects for comparison
  if (selectedSort === "Last 7 Days") {
    filteredData = filteredData.filter(item =>
      dayjs(item[dateField] as string, "YYYY-MM-DD HH:mm:ss").isAfter(now.subtract(7, 'days'))
    );
  } else if (selectedSort === "Last Month") {
    const startOfLastMonth = now.subtract(1, 'month').startOf('month');
    const endOfLastMonth = now.subtract(1, 'month').endOf('month');

    filteredData = filteredData.filter(item => {
      const itemDate = dayjs(item[dateField] as string, "YYYY-MM-DD HH:mm:ss");
      return itemDate.isAfter(startOfLastMonth) && itemDate.isBefore(endOfLastMonth);
    });
  }

  // Fix sorting by parsing dates correctly
  if (selectedSort === "Recently Added") {
    filteredData = filteredData.sort((a, b) =>
      dayjs(b[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf() -
      dayjs(a[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf()
    );
  } else if (selectedSort === "Ascending") {
    filteredData = filteredData.sort((a, b) =>
      dayjs(a[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf() -
      dayjs(b[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf()
    );
  } else if (selectedSort === "Descending") {
    filteredData = filteredData.sort((a, b) =>
      dayjs(b[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf() -
      dayjs(a[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf()
    );
  }

  return filteredData;
};

export const filterDataByRoleAndDate = <T extends Record<string, unknown>>(
  data: T[],
  roleFilter: string | null,
  dateField: string,
  sortField: string,
  selectedSort: FilterOption
): T[] => {
  let filteredData = [...data];

  const now = dayjs();


  if (roleFilter) {
    filteredData = filteredData.filter(item => {
      const itemRole = (item['Role'] as string)?.toLowerCase();
      return itemRole === roleFilter.toLowerCase();
    });
  }

  // Step 2: Apply Date Filter
  if (selectedSort === "Last 7 Days") {
    filteredData = filteredData.filter(item =>
      dayjs(item[dateField] as string, "YYYY-MM-DD HH:mm:ss").isAfter(now.subtract(7, 'days'))
    );
  } else if (selectedSort === "Last Month") {
    filteredData = filteredData.filter(item =>
      dayjs(item[dateField] as string, "YYYY-MM-DD HH:mm:ss").isAfter(now.subtract(1, 'month'))
    );
  }

  // Step 3: Apply Sorting
  if (selectedSort === "Recently Added") {
    filteredData = filteredData.sort((a, b) =>
      dayjs(b[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf() -
      dayjs(a[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf()
    );
  } else if (selectedSort === "Ascending") {
    filteredData = filteredData.sort((a, b) =>
      dayjs(a[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf() -
      dayjs(b[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf()
    );
  } else if (selectedSort === "Descending") {
    filteredData = filteredData.sort((a, b) =>
      dayjs(b[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf() -
      dayjs(a[sortField] as string, "YYYY-MM-DD HH:mm:ss").valueOf()
    );
  }

  return filteredData;
};



export { };